import styled, { css } from 'styled-components';
import { variables } from 'components/theme';
import { ReactComponent as Svg } from 'assets/icons/check_circle.svg';
import { ReactComponent as Svg2 } from 'assets/icons/close.svg';
import {
  cardBackgroundColor,
  cardTextColor,
  itemTextColor,
  itemTitleColor,
  itemMainBackgroundColor
} from 'utils/theme';

const Ellipsis = css`
  width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (max-width: 768px) {
    width: 150px;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  height: 100%;
`;

export const DrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 28px;
  color: ${itemTitleColor};

  .header-title {
    margin-bottom: 7px;
  }

  svg {
    fill: ${itemTitleColor};
  }
`;

export const DrawerBody = styled.div`
  height: 75%;
  overflow-y: overlay;

  @media screen and (max-width: 768px) {
    height: 60%;
  }

  ${({ empty }) =>
    empty &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: center;
    `}
`;

export const NoItemsDisplay = styled.div`
  text-align: center;
  color: ${itemTextColor};

  svg {
    fill: ${itemTextColor};
    width: 100px;
    height: 100px;
  }
`;

export const CheckCircle = styled(Svg)`
  margin: 3.5px 14px 0 0;
`;

export const Close = styled(Svg2)`
  cursor: pointer;
  margin-top: 3.5px;
`;

export const Card = styled.div`
  width: 95%;
  display: flex;
  margin-bottom: 14px;
  background: ${cardBackgroundColor};
  color: ${cardTextColor};
  border: 0.5px solid ${variables.colors.grey13};
  border-radius: 7px;
  font-weight: 600;
  transition: all 150ms ease-in-out;

  p,
  a {
    color: ${itemTextColor};
  }
`;

export const CardMain = styled.div`
  width: 90%;
  padding: 21px;

  @media screen and (max-width: 768px) {
    width: 80%;
    padding: 14px;

    h4 {
      font-size: 14px;
    }

    p {
      font-size: 12px;
    }
  }
`;

export const CardAside = styled.div`
  width: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: 1px solid #aaa;

  p {
    color: ${itemTitleColor};
  }

  button {
    border: none;
    background: ${itemMainBackgroundColor};
  }

  svg {
    fill: ${itemTitleColor};
  }

  ${({ column }) =>
    column &&
    css`
      flex-direction: column;
      justify-content: space-around;
    `}

  @media screen and (max-width: 768px) {
    width: 20%;
  }
`;

export const Delete = styled.button`
  background: ${itemMainBackgroundColor};
  border: none;

  svg {
    fill: ${itemTitleColor};
    vertical-align: middle;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;

  h4 {
    font-weight: 700;
    line-height: 21px;
  }
`;

export const CartImage = styled.div`
  width: 82px;
  height: 82px;
  margin-right: 28px;

  ${({ src }) =>
    src &&
    css`
      background: url(${src}) no-repeat center center/cover;
    `}

  @media screen and (max-width: 768px) {
    width: 60px;
    margin-right: 14px;
  }
`;

export const CartTitle = styled.h4`
  ${Ellipsis}
`;
export const CartDescription = styled.p`
  ${Ellipsis}
`;

export const CartFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const CartButton = styled.button`
  ${variables.fonts.openSansSemiBold}
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  overflow: hidden;
`;

export const CartNumber = styled.div`
  height: 24px;
  width: 24px;
  margin-left: 7px;
  background: ${variables.colors.white};
  border-radius: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
